import * as Yup from 'yup';

import { type TValidationConfig } from '../types/configs';
import { feeConfigNames } from '../types/configNames';
import { FeeFields } from '../types/fieldEnums';

import { getDateValidation, getStringValidation } from './validations';

const getFeeSchema = (operation?: string, validationConfig?: TValidationConfig) =>
  Yup.object().shape({
    receiptNumber: getStringValidation({
      field: feeConfigNames[FeeFields.receiptNumber],
      operation,
      validationConfig,
    }),
    paymentDate: getDateValidation({
      field: feeConfigNames[FeeFields.paymentDate],
      max: new Date(),
      operation,
      validationConfig,
    }),
  });

export default getFeeSchema;
